export const BOOKING_URL = "https://calendar.app.google/i2U8TKw3Qk2GLG7s5";
export const CONTACT_EMAIL = "gary@trxtr.io";

// ── APP SETTINGS ─────────────────────────────────────────────
// Single source of truth for both solutions. A rename is a one-line change here:
// edit name / shortName / tagline / loginUrl and the whole site picks it up.
export const APPS = [
  {
    id: "next-level-motion",
    name: "The Next Level Marketplace Motion",
    shortName: "Next Level Motion",
    buyerName: "Marketplace Deal Options",
    tagline: "Send a buyer page branded as your own — the buyer picks their AWS Marketplace benefits, and the deal moves.",
    path: "/next-level-motion",
    loginUrl: "https://deals.trxtr.io/login",
    loginLabel: "Partner channel",
  },
  {
    id: "private-offer-autopilot",
    name: "Private Offer Autopilot",
    shortName: "Private Offer Autopilot",
    tagline: "From agreed deal to accurate private offer — drafted, approved, released, and tracked to acceptance.",
    path: "/private-offer-autopilot",
    loginUrl: "https://app.trxtr.io/login",
    loginLabel: "Private offers",
  },
];

export const appById = (id) => APPS.find((a) => a.id === id);

export const NAV_LINKS = [
  { label: "Home", to: "/", testid: "nav-home-link" },
  { label: "Solutions", to: "/solutions", testid: "nav-solutions-link" },
  { label: "About", to: "/about", testid: "nav-about-link" },
  { label: "Contact", to: "/contact", testid: "nav-contact-link" },
];
